import { takeLatest, put, call, select } from 'redux-saga/effects';
import { message } from 'antd';
import { findKey } from 'lodash';
import { autoRequest } from '@api/createRequestStore';
import { getTimelineData } from '@api/viewerSessions';
import { sessionTimeline30DaysSaveFeatureSelector } from '@store/common/selectors';
import { PAGE_TYPE } from '@utils/constants';
import * as types from './types';
import * as actions from './actions';
import requestSelector from '../request/selectors';

function* initRequest() {
  yield put(actions.initRequest());
}

function* watchInitRequest() {
  yield takeLatest([types.INIT], initRequest);
}

function* fetching(action) {
  yield actions.fetching();
  const requestPayload = yield select(requestSelector);
  const session30Days = yield select(sessionTimeline30DaysSaveFeatureSelector);
  const dashboardType = findKey(PAGE_TYPE, (value) => value === action.pageType);
  const saveOptions = { shouldSaveSession: session30Days, dashboardType };
  // add dashboard type and 30 days FF
  const updatedPayload = {
    ...requestPayload,
    saveOptions,
  };
  try {
    yield autoRequest(getTimelineData, types.SCOPE, updatedPayload);
  } catch (e) {
    yield call(message.error, e.message || 'Unknown error.');
    // throw e;
  }
}

function* watchFetching() {
  yield takeLatest([types.GET_TIMELINE_DATA], fetching);
}

export default [watchFetching, watchInitRequest];
